import React from 'react'
import styled from 'styled-components'

//@ts-ignore
import { useLivedata } from 'shared/containers/withLivedata'
//@ts-ignore
import { FormLayout } from 'shared/newFormElements'
//@ts-ignore
import { DataSegment } from 'shared/Helpers'

import translate from '../translate'

const Wrapper = styled.div`
  margin-top: 6px;
`

const OpenDay = () => {
  const { openDay } = useLivedata('OpenDayStatus.Open_Day_Str as openDay')

  return (
    <Wrapper>
      <FormLayout labelFieldProportions="6:10" label={translate('lbl_startdate')}>
        <DataSegment style={{ height: '33px', valign: 'center' }}>{openDay}</DataSegment>
      </FormLayout>
    </Wrapper>
  )
}

export default OpenDay
